import { useEffect } from "react";
import { useRouter } from "next/router";
import { useAuthContext } from "./providers/AuthProvider";

export default function LoseAccess() {
  const { setUsuario } = useAuthContext();
  const router = useRouter();

  useEffect(() => {
    setUsuario({});
    router.push("/");

  }, [router, setUsuario]);

  return null;
}
